import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { TableSkeleton } from '@/components/ui/skeleton';

const EmailSequencesPage = lazy(() => import('@/pages/emails/sequences'));

export const Route = createFileRoute('/emails/sequences')({
  component: function EmailSequencesRoute() {
    return (
      <Suspense fallback={<TableSkeleton />}>
        <EmailSequencesPage />
      </Suspense>
    );
  },
});
